import React, { useEffect, useState, useRef } from 'react'
import { SmartLabelType } from './SmartLabelType'
import { SmartLabelShuffle } from './SmartLabelShuffle'
import { SmartLabelAnswer } from './SmartLabelAnswer'
import { SmartLabelSelect } from './SmartLabelSelect'
import { SmartLabelMatch } from './SmartLabelMatch'
import { ImagesFiles } from '../ImageFiles/ImageFiles'
import { getSubmitDate } from '../utils/TimerUtils'
import {
  FEEDBACK_BOT,
  MATCH_BOT,
  SEQUENCE_SELECT,
  SEQUENCE_TYPE,
  TUTOR_BOT
} from '../constants'
import { CaretDown, CaretUp } from '@carbon/icons-react'
import { BotAssistSettings } from '../UIUtilsFiles/BotAssistSettings'
import SmartLabelHint from './SmartLabelHint'

function SmartLabelParentScreen(props) {
  const { user, currentLessonUnitDistId } = props // from redux state
  const {
    activityDataFromParent,
    isBgAudioPlayed,
    minutes,
    seconds,
    isActive,
    onToastTrigger,
    isPreview,
    isSequence,
    isClassroom,
    isMinimize,
    Completed
  } = props

  const {
    activitySaveClick,
    activitySaveType,
    activityResetType,
    canvasAreaDimensions,
    minutesPractice,
    secondsPractice,
    isKnovoHelpOpen,
    muteClicked,
    muteStatus
  } = props //values from parent activity screen
  const {
    getStudentWorkedDataFromChild,
    getStudentCurrentScore,
    getTutorTalking,
    getScreenName,
    getActivityResetStatus,
    knovoHelpClose,
    getValidationFeedback,
    getActivityLoaded
  } = props //values from parent activity screen

  //Activity data
  const [currentActivity, setCurrentActivity] = useState({})
  const {
    ActivityJson,
    ContentMode,
    ContentID,
    ActivityType,
    ContentName,
    Feedback,
    Status,
    FollowTheFlow,
    AutoHint,
    WorkJson
  } = currentActivity
  const SAVE_MODE = { SAVE: 'SAVE', SUBMIT: 'SUBMIT' }
  const isPractice = isPreview
    ? true
    : ActivityType === 'practice'
    ? true
    : false
  const [smartLabelExercise, setSmartLabelExercise] = useState({
    BackgroundImage: '',
    EditorImageHeight: 0,
    EditorImageWidth: 0,
    SmartLabelBoxes: [],
    TotalWeight: 0,
    Opacity: 'rgba(255,255,255,0)',
    TextToSpeech: [],
    Seconds: []
  })

  //Tutor variables
  const [botAudioData, setBotAudioData] = useState('')
  const [ttsData, setTtsData] = useState([])
  const [tutorialStart, setTutorialStart] = useState(false)
  const [isSubtitle, setIsSubtitle] = useState(true)
  const [isTutorPlayed, setIsTutorPlayed] = useState(false)
  const [ttsPlayType, setTtsPlayType] = useState('')
  const [feedbackType, setFeedbackType] = useState('')
  const [isAudioForcedStopped, setIsAudioForcedStopped] = useState(false)
  const [isAudioPlaying, setIsAudioPlaying] = useState(true)
  const [screenName, setScreenName] = useState('')
  const [changeComponent, setChangeComponent] = useState(false)
  // Check Answer variables
  const [currentDisplayMode, setcurrentDisplayMode] = useState('normal')
  const isVerifyMode = currentDisplayMode === 'verify'
  // Answer Explanation
  const [explanationClick, setExplanationClick] = useState(false)
  const [explanationText, setExplanationText] = useState('')
  const [explanationStatus, setExplanationStatus] = useState(false)
  const [explanationVisible, setExplanationVisible] = useState(false)
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  //Teacher feedback variables
  const [feedbackVisible, setFeedbackVisible] = useState(false)
  //Reset variables
  const [resetType, setResetType] = useState('')

  const [modesWorkData, setModesWorkData] = useState([])

  const [getAttempts, setGetAttempts] = useState(0)
  const [getAttemptsPractice, setGetAttemptsPractice] = useState(0)
  const [getCoordinateArray, setGetCoordinateArray] = useState([])
  const [getCurrentScore, setGetCurrentScore] = useState(0)
  const [getCurrentScoreApi, setGetCurrentScoreApi] = useState(0)
  const [getCurrentScoreReset, setGetCurrentScoreReset] = useState(0)
  const [getCumulativeAverageScoreOld, setGetCumulativeAverageScoreOld] =
    useState(0)
  const [getResetDataValue, setGetResetDataValue] = useState(0)
  const [getTotalResetPractice, setGetTotalResetPractice] = useState(0)
  const [getTotalResetOld, setGetTotalResetOld] = useState(0)
  const [getCorrectAnswerList, setGetCorrectAnswerList] = useState([])
  const [getPriorityCount, setGetPriorityCount] = useState(0)
  const [getRemainingList, setGetRemainingList] = useState([])
  //Sequence/succorfail/hint variable
  const [ttsMessageData, setTtsMessageData] = useState('')
  const [ttsPlayStart, setTtsPlayStart] = useState(false)
  const [hideAnimation, setHideAnimation] = useState(false)

  //Hamburger menu variables
  const [isPalleteClose, setIsPalleteClose] = useState(false)

  const [canvasDimension, setCanvasDimension] = useState(undefined)
  const ansContainerRef = useRef()

  const [headerItem, setHeaderItem] = useState('')
  const [isHeaderSkip, setIsHeaderSkip] = useState(false)

  useEffect(() => {
    console.log('isBgAudioPlayed', isBgAudioPlayed)
    if (isBgAudioPlayed) {
      setCurrentActivity(activityDataFromParent)
    } else {
      setSmartLabelData({
        BackgroundImage: '',
        EditorImageHeight: 0,
        EditorImageWidth: 0,
        SmartLabelBoxes: [],
        TotalWeight: 0,
        Opacity: 'rgba(255,255,255,0)',
        TextToSpeech: [],
        Seconds: []
      })
      setIsImageLoaded(false)
      setTtsPlayType('')
      setIsTutorPlayed(false)
      setTutorialStart(false)
      setIsAudioPlaying(false)
      setBotAudioData('')
    }
  }, [isBgAudioPlayed])

  useEffect(() => {
    if (ActivityJson) {
      const exercise = JSON.parse(ActivityJson)
      if (ActivityType === 'test') {
        switch (ContentMode) {
          case 'Match':
            setScreenName('Match')
            break
          case 'Select':
            setScreenName('Select')
            break
          case 'Shuffle':
            setScreenName('Shuffle')
            break
          default:
            setScreenName('Type')
            break
        }
      } else {
        setScreenName('Select')
      }
      setSmartLabelData(exercise)
    }
  }, [currentActivity])

  function setSmartLabelData(exercise) {
    setSmartLabelExercise({
      BackgroundImage: exercise.BackgroundImage,
      EditorImageHeight: exercise.EditorImageHeight,
      EditorImageWidth: exercise.EditorImageWidth,
      TotalWeight: exercise.TotalWeight,
      SmartLabelBoxes: exercise.SmartLabelBoxes,
      Opacity: exercise.Opacity,
      TextToSpeech: exercise.TextToSpeech,
      Seconds: exercise.Seconds
    })
  }

  //check tutor message is available and play
  useEffect(() => {
    if (smartLabelExercise.BackgroundImage !== '') {
      if (isActive && Completed === 0) {
        checkTutorInstructions()
      } else {
        setTutorialStart(false)
        setIsTutorPlayed(true)
      }
    }
  }, [smartLabelExercise])

  //check tutor message is available and play
  function checkTutorInstructions() {
    let botTtsData = getTutorAudio()
    if (botTtsData.tutorTtsAudio !== '') {
      setTtsPlayType(TUTOR_BOT)
      setBotAudioData(botTtsData.tutorTtsAudio)
      setTutorialStart(true)
    } else {
      setTutorialStart(false)
      setIsTutorPlayed(true)
    }
    if (botTtsData.tutorTtsText !== '') {
      setTtsData(botTtsData.tutorTtsText)
    }
  }

  //Get initial instructions data
  function getTutorAudio() {
    const exercise = JSON.parse(ActivityJson)
    let tutorBotData = {
      tutorTtsAudio: '',
      tutorTtsText: []
    }
    if (exercise.SpeechAudioData) {
      let activityInitialInstruction = exercise.SpeechAudioData
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsAudio = activityInitialInstruction.speechAudioLink
      }
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsText = activityInitialInstruction.speechData
      }
    }
    return tutorBotData
  }

  useEffect(() => {
    if (isTutorPlayed) {
      setBotAudioData('')
      if (!isPreview) {
        setWorkJsonData()
      }
    }
  }, [isTutorPlayed])

  useEffect(() => {
    getStudentCurrentScore(getCurrentScore)
  }, [getCurrentScore])

  useEffect(() => {
    getScreenName(screenName, modesWorkData)
  }, [modesWorkData])

  function setWorkJsonData() {
    if (WorkJson !== '') {
      setModesWorkData(JSON.parse(WorkJson))
    } else {
      setModesWorkData([])
    }
    setHideAnimation(true)
  }

  function setModesDataCall() {
    // console.log("getCoordinatearray", getCoordinateArray);
    let listArray = getCoordinateArray.map((c, index) => {
      return {
        CtlId: c.ControlID,
        CtlValue: c.defaultValue,
        elapsedTime: c.elapsedTime
      }
    })
    let workData = {
      ContentID: ContentID,
      ModeName: screenName,
      Score: getCurrentScore,
      TimeTaken: minutesPractice + ':' + secondsPractice,
      Attempts: getAttemptsPractice,
      listControls: listArray,
      isResetDone: getResetDataValue,
      TotalScore: isPractice ? getCurrentScoreApi : getCurrentScore,
      TimeTakenOverall: minutes + ':' + seconds,
      AttemptsOverall: getAttempts,
      TotalResetPractice: getTotalResetPractice,
      ResetScore: getCurrentScoreReset,
      CumulativeAverageScoreOld: getCumulativeAverageScoreOld,
      TotalResetOld: getTotalResetOld,
      CumulativeAverage: calculateAverage(),
      ScorePractice: !isPractice ? getCurrentScore : scoreForPractice(),
      Platform: 'Web'
    }
    if (screenName === 'Type') {
      workData.correctAnswerList = getCorrectAnswerList
      workData.priorityCount = getPriorityCount
    } else if (screenName === 'Select') {
      workData.priorityCount = getPriorityCount
    } else if (screenName === 'Match') {
      workData.remainingList = getRemainingList
    }
    let allWorkData = []
    if (
      modesWorkData.filter(
        (e) => e.ContentID === ContentID && e.ModeName === screenName
      ).length > 0
    ) {
      const workJsonCopy = [...modesWorkData]
      const index = workJsonCopy.findIndex(
        (element) =>
          element.ContentID === ContentID && element.ModeName === screenName
      )
      workJsonCopy[index] = workData
      allWorkData = workJsonCopy
    } else {
      allWorkData = [...modesWorkData, workData]
    }
    return allWorkData
  }

  function saveModeWorkData(modeName) {
    setcurrentDisplayMode('normal')
    knovoHelpClose()
    setTtsPlayType('')
    setBotAudioData('')
    if (screenName !== 'Answer') {
      setModesWorkData(setModesDataCall())
      setScreenName(modeName)
    } else {
      setScreenName(modeName)
    }
  }

  function calculateAverage() {
    let overallAverageScore = 0
    let modifyCurrentScore = 0
    if (
      smartLabelExercise.TotalWeight &&
      smartLabelExercise.TotalWeight !== 0
    ) {
      let calculateScAt = calculateTotalComponents()
      if (calculateScAt < 1) {
        let modifyScore = Math.round(getCurrentScore * calculateScAt)
        modifyCurrentScore = modifyScore
      } else {
        modifyCurrentScore = getCurrentScore
      }
      let currentAverageScore = Math.round(
        (modifyCurrentScore / smartLabelExercise.TotalWeight) * 100
      )
      if (getCumulativeAverageScoreOld === 0) {
        overallAverageScore = Math.round(
          (modifyCurrentScore / smartLabelExercise.TotalWeight) * 100
        )
      } else {
        overallAverageScore = Math.round(
          Math.round(
            (getCumulativeAverageScoreOld * getTotalResetOld +
              currentAverageScore) /
              (getTotalResetPractice + 1)
          )
        )
      }
    }
    return overallAverageScore
  }

  function calculateTotalComponents() {
    const exercise = JSON.parse(ActivityJson)
    let noOfComponents = exercise.SmartLabelBoxes.length
    let calculateScAt = 0
    if (getAttemptsPractice !== 0) {
      calculateScAt = noOfComponents / getAttemptsPractice
    }
    return calculateScAt
  }

  function scoreForPractice() {
    let modifyCurrentScore = 0
    let calculateScAt = calculateTotalComponents()
    if (calculateScAt < 1) {
      let modifyScore = Math.round(getCurrentScore * calculateScAt)
      modifyCurrentScore = modifyScore
    } else {
      modifyCurrentScore = getCurrentScore
    }
    return modifyCurrentScore
  }

  useEffect(() => {
    if (Completed === 0 && isActive) {
      if (screenName === 'Type' || screenName === 'Select') {
        if (getPriorityCount > 0) {
          if (smartLabelExercise.SmartLabelBoxes.length > 0) {
            const index = smartLabelExercise.SmartLabelBoxes.findIndex(
              (element) => element.Priority === getPriorityCount
            )
            if (
              smartLabelExercise.SmartLabelBoxes[index] &&
              smartLabelExercise.SmartLabelBoxes[index].SequenceHint &&
              smartLabelExercise.SmartLabelBoxes[index].SequenceHint !== ''
            ) {
              setTtsMessageData(
                smartLabelExercise.SmartLabelBoxes[index].SequenceHint
              )
              if (FollowTheFlow) {
                setHideAnimation(false)
                setTtsPlayStart(true)
              }
            } else {
              setTtsMessageData('')
              setHideAnimation(true)
            }
          }
        }
      }
    }
  }, [getPriorityCount])

  // Setting Answer Explanation
  function handleExplanationChange(explanationStatus, explanationString) {
    if (explanationString && explanationString !== '') {
      setExplanationText(explanationString)
      setExplanationStatus(explanationStatus)
      setExplanationVisible(true)
    } else {
      setExplanationVisible(false)
    }
  }

  //save studentDataCall
  useEffect(() => {
    if (activitySaveClick) {
      getStudentWork()
    }
  }, [activitySaveClick])

  //call when reset click
  useEffect(() => {
    setResetType(activityResetType)
  }, [activityResetType])

  function getStudentWork() {
    setcurrentDisplayMode('normal')
    const completed = activitySaveType === SAVE_MODE.SAVE ? 0 : 1
    const resetData =
      activitySaveType === SAVE_MODE.SAVE ? getResetDataValue : 0
    let apiWorkData = setModesDataCall()
    let studentActivityData = JSON.stringify({
      LessonUnitDistID: currentLessonUnitDistId,
      StudentID: user.LoginID,
      DomainID: user.DomainID,
      ContentID: ContentID,
      Completed: completed,
      TotalPoints: !isPractice
        ? getTotScore(apiWorkData)
        : getTotScorePractice(apiWorkData),
      Attempts: getTotAttempts(apiWorkData),
      Work: JSON.stringify(apiWorkData),
      Ink: '',
      SpentTime: getTimeSpentApi(apiWorkData),
      Reset: resetData,
      SubmitDate: getSubmitDate(),
      CumulativeAttempts: getTotAttemptsOverall(apiWorkData),
      CumulativeTimeTaken: getTimeSpentOverallToApi(apiWorkData),
      CumulativeAverage: getTotCumulativeAverage(apiWorkData),
      TotalTries: getTotReset(apiWorkData)
    })
    getStudentWorkedDataFromChild(studentActivityData)
  }

  //add total score for api
  function getTotScore(labelModesData) {
    if (!isPractice) {
      return getCurrentScore
    }
    let totalScore = 0
    labelModesData.forEach((element) => {
      totalScore = totalScore + element.Score
    })
    return totalScore
  }

  function getTotScorePractice(labelModesData) {
    if (!isPractice) {
      return getCurrentScore
    }
    let totalScorePractice = 0
    labelModesData.forEach((element) => {
      if (element.ScorePractice) {
        totalScorePractice = totalScorePractice + element.ScorePractice
      }
    })
    return totalScorePractice
  }

  function getTotAttempts(labelModesData) {
    if (!isPractice) {
      return getAttemptsPractice
    }
    let totalAttempts = 0
    labelModesData.forEach((element) => {
      if (element.Attempts) {
        totalAttempts = totalAttempts + element.Attempts
      }
    })
    return totalAttempts
  }

  function getTotAttemptsOverall(labelModesData) {
    if (!isPractice) {
      return getAttempts
    }
    let totalAttempts = 0
    labelModesData.forEach((element) => {
      if (element.AttemptsOverall) {
        totalAttempts = totalAttempts + element.AttemptsOverall
      }
    })
    return totalAttempts
  }

  function getTotCumulativeAverage(labelModesData) {
    if (!isPractice) {
      return 0
    }
    let totalCumulativeAverage = 0
    let numberOfModes = labelModesData.length
    labelModesData.forEach((element) => {
      if (element.CumulativeAverage) {
        totalCumulativeAverage = Math.round(
          totalCumulativeAverage + element.CumulativeAverage
        )
      }
    })
    totalCumulativeAverage = Math.round(totalCumulativeAverage / numberOfModes)
    return totalCumulativeAverage
  }

  //cumulative
  function getTimeSpentOverallToApi(labelModesData) {
    if (!isPractice) {
      return minutes + ':' + ('0' + seconds).slice(-2)
    }
    let totalMins = 0
    let totalSecs = 0
    labelModesData.forEach((element) => {
      if (element.TimeTakenOverall) {
        totalMins = element.TimeTakenOverall.split(':')[0]
          ? totalMins + parseInt(element.TimeTakenOverall.split(':')[0])
          : totalMins
        totalSecs = element.TimeTakenOverall.split(':')[1]
          ? totalSecs + parseInt(element.TimeTakenOverall.split(':')[1])
          : totalSecs
      }
    })
    while (totalSecs > 59) {
      totalMins = totalMins + 1
      totalSecs = totalSecs - 60
    }
    return totalMins + ':' + ('0' + totalSecs).slice(-2)
  }

  function getTimeSpentApi(labelModesData) {
    if (!isPractice) {
      return minutesPractice + ':' + ('0' + secondsPractice).slice(-2)
    }
    let totalMins = 0
    let totalSecs = 0
    labelModesData.forEach((element) => {
      if (element.TimeTaken) {
        totalMins = element.TimeTaken.split(':')[0]
          ? totalMins + parseInt(element.TimeTaken.split(':')[0])
          : totalMins
        totalSecs = element.TimeTaken.split(':')[1]
          ? totalSecs + parseInt(element.TimeTaken.split(':')[1])
          : totalSecs
      }
    })
    while (totalSecs > 59) {
      totalMins = totalMins + 1
      totalSecs = totalSecs - 60
    }
    return totalMins + ':' + ('0' + totalSecs).slice(-2)
  }

  function getTotReset(labelModesData) {
    if (!isPractice) {
      return 0
    }
    let totalReset = 0
    let numberOfModes = labelModesData.length
    labelModesData.forEach((element) => {
      if (element.TotalResetPractice || element.TotalResetPractice >= 0) {
        totalReset = Math.round(totalReset + element.TotalResetPractice + 1)
      }
    })
    totalReset = Math.round(totalReset / numberOfModes)
    return totalReset
  }

  function clearDataReset() {
    setcurrentDisplayMode('normal')
    knovoHelpClose()
    if (isPractice) {
      setScreenName('Type')
    }
    let modesWorkDataCopy = setModesDataCall()
    modesWorkDataCopy.forEach((element) => {
      //Clear the student work data
      if (element.listControls) {
        element.listControls = []
        element.TimeTaken = '0:00'
        element.Attempts = 0
      }
      //Clear the sequence priority
      if (element.ModeName === 'Type' || element.ModeName === 'Select') {
        element.priorityCount = 1
        if (element.correctAnswerList) {
          element.correctAnswerList = []
        }
      }
    })
    setModesWorkData(modesWorkDataCopy)
    getActivityResetStatus()
  }

  //Call when background image is loaded
  useEffect(() => {
    if (isImageLoaded) {
      var myImg = document.querySelector('#sky' + ContentID)
      var imageRealWidth = myImg.naturalWidth
      var imageRealHeight = myImg.naturalHeight
      var ansContWidth = canvasAreaDimensions.width
      var ansContHeight = canvasAreaDimensions.height
      if (
        imageRealWidth > imageRealHeight &&
        (imageRealHeight * ansContWidth) / imageRealWidth <= ansContHeight
      ) {
        setCanvasDimension({
          width: ansContWidth,
          height: (imageRealHeight * ansContWidth) / imageRealWidth
        })
      } else {
        setCanvasDimension({
          width: (ansContHeight * imageRealWidth) / imageRealHeight,
          height: ansContHeight
        })
      }
      getActivityLoaded(false)
    }
  }, [isImageLoaded])

  //Feedback audio function
  function onFeedbackChange(feedbackText, feedbackAudio, status) {
    if (isPractice) {
      setFeedbackType(status)
      setTtsPlayType(FEEDBACK_BOT)
      setBotAudioData(feedbackAudio)
      setTtsData(feedbackText)
      setTutorialStart(true)
    }
  }

  useEffect(() => {
    if (changeComponent) {
      setTimeout(() => {
        setChangeComponent(false)
      }, 200)
    }
  }, [changeComponent])

  function renderLabelFooter() {
    return (
      <div
        className={
          isPalleteClose
            ? 'footer-cont footer-cont-collapse'
            : 'footer-cont footer-cont-open'
        }
      >
        <div
          className='footer-arrow-cont'
          onClick={() => {
            if (isTutorPlayed) {
              setIsPalleteClose((floating) => !floating)
            }
          }}
        >
          {isPalleteClose ? (
            <CaretUp color='#4922FD' size={22} />
          ) : (
            <CaretDown color='#4922FD' size={22} />
          )}
        </div>
        <div className='footer-icons-cont'>
          {/* Select Mode */}
          <div
            className='label-icons-cont'
            style={{
              display: isPractice
                ? 'flex'
                : screenName === 'Select'
                ? 'flex'
                : 'none',
              pointerEvents: !isAudioPlaying ? 'none' : 'auto'
            }}
            onClick={() => saveModeWorkData('Select')}
          >
            <img
              className='label-icon-size'
              src={
                screenName === 'Select'
                  ? ImagesFiles.label_select_selected
                  : ImagesFiles.label_select
              }
            />
            <p className='label-text'>Select</p>
          </div>
          {/* Shuffle Mode */}
          <div
            className='label-icons-cont'
            style={{
              display: isPractice
                ? 'flex'
                : screenName === 'Shuffle'
                ? 'flex'
                : 'none',
              pointerEvents: !isAudioPlaying ? 'none' : 'auto'
            }}
            onClick={() => saveModeWorkData('Shuffle')}
          >
            <img
              className='label-icon-size'
              src={
                screenName === 'Shuffle'
                  ? ImagesFiles.label_shuffle_selected
                  : ImagesFiles.label_shuffle
              }
            />
            <p className='label-text'>Shuffle</p>
          </div>
          {/* Match Mode */}
          <div
            className='label-icons-cont'
            style={{
              display: isPractice
                ? 'flex'
                : screenName === 'Match'
                ? 'flex'
                : 'none',
              pointerEvents: !isAudioPlaying ? 'none' : 'auto'
            }}
            onClick={() => saveModeWorkData('Match')}
          >
            <img
              className='label-icon-size'
              src={
                screenName === 'Match'
                  ? ImagesFiles.label_match_selected
                  : ImagesFiles.label_match
              }
            />
            <p className='label-text'>Match</p>
          </div>
          {/* Type Mode */}
          <div
            className='label-icons-cont'
            style={{
              display: isPractice
                ? 'flex'
                : screenName === 'Type'
                ? 'flex'
                : 'none',
              pointerEvents: !isAudioPlaying ? 'none' : 'auto'
            }}
            onClick={() => saveModeWorkData('Type')}
          >
            <img
              className='label-icon-size'
              src={
                screenName === 'Type'
                  ? ImagesFiles.label_type_selected
                  : ImagesFiles.label_type
              }
            />
            <p className='label-text'>Type</p>
          </div>
          <div
            className='label-icons-cont'
            style={{
              display: isPractice
                ? 'flex'
                : screenName === 'Answer'
                ? 'flex'
                : 'none',
              pointerEvents: !isAudioPlaying ? 'none' : 'auto'
            }}
            onClick={() => saveModeWorkData('Answer')}
          >
            <img
              className='label-icon-size'
              src={
                screenName === 'Answer'
                  ? ImagesFiles.label_answer_selected
                  : ImagesFiles.label_answer
              }
            />
            <p className='label-text'>Answer</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ backgroundColor: '#e0e0e0', width: '100%', height: '100%' }}>
      <div
        ref={ansContainerRef}
        style={{
          height: '100%',
          width: '100%',
          backgroundColor: '#e0e0e0',
          display: 'flex'
        }}
      >
        <div
          style={{
            padding: 0,
            margin: 'auto',
            objectFit: 'contain',
            width: canvasDimension && canvasDimension.width,
            height: canvasDimension && canvasDimension.height,
            background: 'white',
            display: 'flex',
            alignSelf: 'center',
            position: 'relative',
            backgroundImage: `url(${smartLabelExercise.BackgroundImage})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            filter: isTutorPlayed ? 'none' : 'blur(5px)'
          }}
        >
          <img
            alt='smartLabelExercise'
            id={'sky' + ContentID}
            src={smartLabelExercise.BackgroundImage}
            style={{
              zIndex: 0,
              objectFit: 'contain',
              width: canvasDimension && canvasDimension.width,
              height: canvasDimension && canvasDimension.height,
              display: 'none'
            }}
            onLoad={() => {
              setIsImageLoaded(true)
            }}
          />
          <span
            style={{
              backgroundColor: smartLabelExercise.Opacity,
              height: '100%',
              width: '100%',
              position: 'absolute'
            }}
          />
          {isImageLoaded &&
            isBgAudioPlayed &&
            (screenName === 'Type' ? (
              <SmartLabelType
                getAttempts={(attemptsValue) => {
                  setGetAttempts(attemptsValue)
                }}
                getAttemptsPractice={(attemptsPracValue) => {
                  setGetAttemptsPractice(attemptsPracValue)
                }}
                getCoordinateArray={(coordinateArrayValue) => {
                  setGetCoordinateArray(coordinateArrayValue)
                }}
                getCurrentScore={(currentScoreValue) => {
                  setGetCurrentScore(currentScoreValue)
                }}
                getCurrentScoreApi={(currentScoreApiValue) => {
                  setGetCurrentScoreApi(currentScoreApiValue)
                }}
                getCurrentScoreReset={(currentScoreResetValue) => {
                  setGetCurrentScoreReset(currentScoreResetValue)
                }}
                getCumulativeAverageScoreOld={(
                  cumulativeAverageScoreOldValue
                ) => {
                  setGetCumulativeAverageScoreOld(
                    cumulativeAverageScoreOldValue
                  )
                }}
                getResetDataValue={(resetDataValue) => {
                  setGetResetDataValue(resetDataValue)
                }}
                getTotalResetPractice={(totalResetPracticeValue) => {
                  setGetTotalResetPractice(totalResetPracticeValue)
                }}
                getTotalResetOld={(totalResetOldValue) => {
                  setGetTotalResetOld(totalResetOldValue)
                }}
                getCorrectAnswerList={(correctAnswerList) => {
                  setGetCorrectAnswerList(correctAnswerList)
                }}
                getPriorityCount={(priorityCount) => {
                  setGetPriorityCount(priorityCount)
                }}
                clearReset={() => {
                  clearDataReset()
                  setResetType('')
                  setExplanationClick(false)
                }}
                getValidationFeedback={(feedbackType, status) => {
                  getValidationFeedback(feedbackType, status)
                  //handleFeedbackAudio(feedbackType)
                }}
                getFeedbackData={(
                  feedbackText,
                  feedbackAudio,
                  feedbackStatus
                ) => {
                  onFeedbackChange(feedbackText, feedbackAudio, feedbackStatus)
                }}
                // getAllWorkData={(modesAllWorkData)=>{setTypeWorkData(modesAllWorkData)}}
                handleExplanationChange={handleExplanationChange}
                isImageLoaded={isImageLoaded}
                isActive={isActive}
                seconds={seconds}
                minutes={minutes}
                secondsPractice={secondsPractice}
                minutesPractice={minutesPractice}
                isVerifyMode={isVerifyMode}
                explanationClick={explanationClick}
                smartLabelExercise={smartLabelExercise}
                ActivityJson={ActivityJson}
                Completed={Completed}
                ContentID={ContentID}
                isPractice={isPractice}
                ContentName={ContentName}
                Feedback={Feedback}
                Status={Status}
                FollowTheFlow={isPreview ? isSequence : FollowTheFlow}
                AutoHint={AutoHint}
                modesWorkData={modesWorkData}
                resetClick={resetType}
                isBgAudioPlayed={isTutorPlayed}
                changeComponent={changeComponent}
                isAudioPlaying={!isAudioPlaying}
                isPreview={isPreview}
              />
            ) : screenName === 'Shuffle' ? (
              <SmartLabelShuffle
                getAttempts={(attemptsValue) => {
                  setGetAttempts(attemptsValue)
                }}
                getAttemptsPractice={(attemptsPracValue) => {
                  setGetAttemptsPractice(attemptsPracValue)
                }}
                getCoordinateArray={(coordinateArrayValue) => {
                  setGetCoordinateArray(coordinateArrayValue)
                }}
                getCurrentScore={(currentScoreValue) => {
                  setGetCurrentScore(currentScoreValue)
                }}
                getCurrentScoreApi={(currentScoreApiValue) => {
                  setGetCurrentScoreApi(currentScoreApiValue)
                }}
                getCurrentScoreReset={(currentScoreResetValue) => {
                  setGetCurrentScoreReset(currentScoreResetValue)
                }}
                getCumulativeAverageScoreOld={(
                  cumulativeAverageScoreOldValue
                ) => {
                  setGetCumulativeAverageScoreOld(
                    cumulativeAverageScoreOldValue
                  )
                }}
                getResetDataValue={(resetDataValue) => {
                  setGetResetDataValue(resetDataValue)
                }}
                getTotalResetPractice={(totalResetPracticeValue) => {
                  setGetTotalResetPractice(totalResetPracticeValue)
                }}
                getTotalResetOld={(totalResetOldValue) => {
                  setGetTotalResetOld(totalResetOldValue)
                }}
                clearReset={() => {
                  clearDataReset()
                  setResetType('')
                  setExplanationClick(false)
                }}
                getHintMessage={(hintMessage) => {
                  setTtsPlayStart(false)
                  setTtsMessageData(hintMessage)
                }}
                handleExplanationChange={handleExplanationChange}
                getValidationFeedback={(feedbackType, status) => {
                  getValidationFeedback(feedbackType, status)
                }}
                getFeedbackData={(
                  feedbackText,
                  feedbackAudio,
                  feedbackStatus
                ) => {
                  onFeedbackChange(feedbackText, feedbackAudio, feedbackStatus)
                }}
                isImageLoaded={isImageLoaded}
                isActive={isActive}
                seconds={seconds}
                minutes={minutes}
                secondsPractice={secondsPractice}
                minutesPractice={minutesPractice}
                isVerifyMode={isVerifyMode}
                explanationClick={explanationClick}
                smartLabelExercise={smartLabelExercise}
                ActivityJson={ActivityJson}
                Completed={Completed}
                ContentID={ContentID}
                isPractice={isPractice}
                ContentName={ContentName}
                Feedback={Feedback}
                Status={Status}
                FollowTheFlow={isPreview ? isSequence : FollowTheFlow}
                AutoHint={AutoHint}
                modesWorkData={modesWorkData}
                resetClick={resetType}
                isBgAudioPlayed={isTutorPlayed}
                isAudioPlaying={!isAudioPlaying}
                isPreview={isPreview}
              />
            ) : screenName === 'Select' ? (
              <SmartLabelSelect
                getAttempts={(attemptsValue) => {
                  setGetAttempts(attemptsValue)
                }}
                getAttemptsPractice={(attemptsPracValue) => {
                  setGetAttemptsPractice(attemptsPracValue)
                }}
                getCoordinateArray={(coordinateArrayValue) => {
                  setGetCoordinateArray(coordinateArrayValue)
                }}
                getCurrentScore={(currentScoreValue) => {
                  setGetCurrentScore(currentScoreValue)
                }}
                getCurrentScoreApi={(currentScoreApiValue) => {
                  setGetCurrentScoreApi(currentScoreApiValue)
                }}
                getCurrentScoreReset={(currentScoreResetValue) => {
                  setGetCurrentScoreReset(currentScoreResetValue)
                }}
                getCumulativeAverageScoreOld={(
                  cumulativeAverageScoreOldValue
                ) => {
                  setGetCumulativeAverageScoreOld(
                    cumulativeAverageScoreOldValue
                  )
                }}
                getResetDataValue={(resetDataValue) => {
                  setGetResetDataValue(resetDataValue)
                }}
                getTotalResetPractice={(totalResetPracticeValue) => {
                  setGetTotalResetPractice(totalResetPracticeValue)
                }}
                getTotalResetOld={(totalResetOldValue) => {
                  setGetTotalResetOld(totalResetOldValue)
                }}
                getPriorityCount={(priorityCount) => {
                  setGetPriorityCount(priorityCount)
                }}
                clearReset={() => {
                  clearDataReset()
                  setResetType('')
                  setExplanationClick(false)
                }}
                handleExplanationChange={handleExplanationChange}
                getValidationFeedback={(feedbackType, status) => {
                  getValidationFeedback(feedbackType, status)
                }}
                getFeedbackData={(
                  feedbackText,
                  feedbackAudio,
                  feedbackStatus
                ) => {
                  onFeedbackChange(feedbackText, feedbackAudio, feedbackStatus)
                }}
                isImageLoaded={isImageLoaded}
                isActive={isActive}
                seconds={seconds}
                minutes={minutes}
                secondsPractice={secondsPractice}
                minutesPractice={minutesPractice}
                isVerifyMode={isVerifyMode}
                explanationClick={explanationClick}
                smartLabelExercise={smartLabelExercise}
                ActivityJson={ActivityJson}
                Completed={Completed}
                ContentID={ContentID}
                isPractice={isPractice}
                ContentName={ContentName}
                Feedback={Feedback}
                Status={Status}
                FollowTheFlow={isPreview ? isSequence : FollowTheFlow}
                AutoHint={AutoHint}
                modesWorkData={modesWorkData}
                resetClick={resetType}
                isBgAudioPlayed={isTutorPlayed}
                isAudioPlaying={!isAudioPlaying}
                isPreview={isPreview}
              />
            ) : screenName === 'Match' ? (
              <SmartLabelMatch
                getAttempts={(attemptsValue) => {
                  setGetAttempts(attemptsValue)
                }}
                getAttemptsPractice={(attemptsPracValue) => {
                  setGetAttemptsPractice(attemptsPracValue)
                }}
                getCoordinateArray={(coordinateArrayValue) => {
                  setGetCoordinateArray(coordinateArrayValue)
                }}
                getCurrentScore={(currentScoreValue) => {
                  setGetCurrentScore(currentScoreValue)
                }}
                getCurrentScoreApi={(currentScoreApiValue) => {
                  setGetCurrentScoreApi(currentScoreApiValue)
                }}
                getCurrentScoreReset={(currentScoreResetValue) => {
                  setGetCurrentScoreReset(currentScoreResetValue)
                }}
                getCumulativeAverageScoreOld={(
                  cumulativeAverageScoreOldValue
                ) => {
                  setGetCumulativeAverageScoreOld(
                    cumulativeAverageScoreOldValue
                  )
                }}
                getResetDataValue={(resetDataValue) => {
                  setGetResetDataValue(resetDataValue)
                }}
                getTotalResetPractice={(totalResetPracticeValue) => {
                  setGetTotalResetPractice(totalResetPracticeValue)
                }}
                getTotalResetOld={(totalResetOldValue) => {
                  setGetTotalResetOld(totalResetOldValue)
                }}
                getRemainingList={(remainingList) => {
                  setGetRemainingList(remainingList)
                }}
                clearReset={() => {
                  clearDataReset()
                  setResetType('')
                  setExplanationClick(false)
                }}
                getHintMessage={(hintMessage) => {
                  setTtsPlayStart(false)
                  setTtsMessageData(hintMessage)
                }}
                onHeaderChange={(headerValue) => {
                  setHeaderItem(headerValue)
                }}
                onSkipComplete={() => {
                  setIsHeaderSkip(false)
                }}
                handleExplanationChange={handleExplanationChange}
                getValidationFeedback={(feedbackType, status) => {
                  getValidationFeedback(feedbackType, status)
                }}
                getFeedbackData={(
                  feedbackText,
                  feedbackAudio,
                  feedbackStatus
                ) => {
                  onFeedbackChange(feedbackText, feedbackAudio, feedbackStatus)
                }}
                getHeaderElement={(headerElement, botStatus) => {
                  if (Object.keys(headerElement).length > 0) {
                    const labelData =
                      headerElement.FeedbackAudioData.labelAudioData
                    if (labelData) {
                      setTtsPlayType(MATCH_BOT)
                      setBotAudioData(labelData.speechAudioLink)
                      setTtsData(labelData.speechData)
                      setTutorialStart(true)
                    }
                  } else {
                    if (ttsPlayType === MATCH_BOT) {
                      setTtsPlayType(TUTOR_BOT)
                      setBotAudioData('')
                      setTtsData([])
                      setTutorialStart(false)
                    }
                  }
                }}
                onToastTrigger={onToastTrigger}
                isImageLoaded={isImageLoaded}
                isActive={isActive}
                seconds={seconds}
                minutes={minutes}
                secondsPractice={secondsPractice}
                minutesPractice={minutesPractice}
                isVerifyMode={isVerifyMode}
                explanationClick={explanationClick}
                smartLabelExercise={smartLabelExercise}
                ActivityJson={ActivityJson}
                Completed={Completed}
                ContentID={ContentID}
                isPractice={isPractice}
                ContentName={ContentName}
                Feedback={Feedback}
                Status={Status}
                FollowTheFlow={isPreview ? isSequence : FollowTheFlow}
                AutoHint={AutoHint}
                modesWorkData={modesWorkData}
                resetClick={resetType}
                isBgPlayed={isTutorPlayed}
                isHeaderSkip={isHeaderSkip}
                isAudioPlaying={!isAudioPlaying}
                changeComponent={changeComponent}
                isPreview={isPreview}
              />
            ) : (
              <SmartLabelAnswer
                isImageLoaded={isImageLoaded}
                isActive={isActive}
                seconds={seconds}
                minutes={minutes}
                secondsPractice={secondsPractice}
                minutesPractice={minutesPractice}
                isVerifyMode={isVerifyMode}
                explanationClick={explanationClick}
                smartLabelExercise={smartLabelExercise}
                ActivityJson={ActivityJson}
                Completed={Completed}
                ContentID={ContentID}
                isPractice={isPractice}
                ContentName={ContentName}
                Feedback={Feedback}
                Status={Status}
                FollowTheFlow={isPreview ? isSequence : FollowTheFlow}
                AutoHint={AutoHint}
                modesWorkData={modesWorkData}
                resetClick={resetType}
                isBgPlayed={isTutorPlayed}
              />
            ))}
        </div>
      </div>
      {/* {isKnovoHelpOpen && (
        <KnovoHelp
          Completed={Completed}
          isActive={isActive}
          isPractice={isPractice}
          onBotAnimeClose={() => {
            setcurrentDisplayMode("normal");
            knovoHelpClose();
          }}
          onKnovoHelpSelected={(helpSelected, isShowAnswer) => {
            if (helpSelected === "tips") {
              setcurrentDisplayMode("normal");
              knovoHelpClose();
            } else if (helpSelected === "instruction") {
              setcurrentDisplayMode("normal");
              knovoHelpClose();
            } else if (helpSelected === "walkthrough") {
              setcurrentDisplayMode("normal");
              knovoHelpClose();
              //  knovoActivityTourClick();
            } else {
              if (isPractice || Completed === 1 || !isActive) {
                if (isShowAnswer) {
                  setcurrentDisplayMode("verify");
                } else {
                  setcurrentDisplayMode("normal");
                }
              }
            }
          }}
        />
      )} */}
      {/* {Completed === 0 &&
        isActive &&
        !isKnovoHelpOpen &&
        headerItem &&
        headerItem !== "" &&
        screenName === "Match" && (
          <SmartLabelHint
            headerItem={headerItem}
            onSkipClick={() => {
              setIsHeaderSkip(true);
            }}
          />
        )}
      <TeacherFeedback
        feedbackVisible={feedbackVisible}
        Feedback={Feedback}
        onPopupCancel={() => {
          setFeedbackVisible(false);
        }}
      /> */}
      {/* <AnswerExplanation
        explanationVisible={explanationVisible}
        explanationStatus={explanationStatus}
        explanationText={explanationText}
        onExplanationClosed={() => {
          setExplanationVisible(false);
        }}
      /> */}
      {isBgAudioPlayed && renderLabelFooter()}
      {/* {Completed === 0 &&
        isActive &&
        !isKnovoHelpOpen && 
        headerItem &&
        headerItem !== "" &&
        screenName === "Match" && (
          <SmartLabelHint
            headerItem={headerItem}
            onSkipClick={() => {
              setIsHeaderSkip(true);
            }}
          />
        )} */}
      {botAudioData !== '' && (
        <BotAssistSettings
          isBgAudioPlayed={isBgAudioPlayed}
          audioUrl={botAudioData}
          text={ttsData}
          tutorialStart={tutorialStart}
          botType={ttsPlayType}
          getTutorTalking={(audioStatus) => {
            setIsAudioPlaying(audioStatus)
            getTutorTalking(audioStatus)
          }}
          isAudioForcedStopped={isAudioForcedStopped}
          isMinimize={isMinimize}
          onBotComplete={() => {
            setTutorialStart(false)
            setIsTutorPlayed(true)
            if (ttsPlayType === FEEDBACK_BOT) {
              setTtsPlayType('')
              setBotAudioData('')
              setChangeComponent(true)
              // if (feedbackType === 'failure') {
              //   setTtsPlayType(MATCH_BOT)
              // }
            }
          }}
          onBotStopped={() => {
            setTutorialStart(false)
          }}
          onFrwdSkipClick={() => {}}
          headerItem={headerItem}
          onSkipClick={() => {
            setIsHeaderSkip(true)
          }}
        />
      )}
    </div>
  )
}

export { SmartLabelParentScreen }
